<template>
  <div>
    <el-dialog
      :visible="true"
      width="800px"
      class="chartDia"
      :show-close="false"
      @close="close"
      v-loading="loading < 2"
    >
      <div slot="title" class="slotTit">{{ finalStatus | transPayStatus }}</div>
      <div v-if="finalStatus == 2 || finalStatus == 5" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">系统正在对订单进行支付，请耐心等待</div>
      </div>
      <div v-else-if="finalStatus == 7" class="imgBox">
        <img src="@/assets/1.png" />
        <div class="imgLabel">支付成功</div>
      </div>
      <div v-else-if="finalStatus == 6" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes" v-if="table.authStatus == 2">
          本次支付失败，请您重新提交支付。
        </div>
        <div class="imgDes" v-else>
          您的账户余额不足，本次支付失败，请重新提交支付
        </div>
      </div>
      <div class="flexBox">
        <div class="leftDiv">
          <b>订单编号：</b>
          {{ table.orderNo }}
        </div>
        <div class="rightDiv">
          <b>企业名称：</b>
          {{ table.enterpriseName }}
        </div>
      </div>
      <div class="flexBox">
        <div class="leftDiv">
          <b>项目名称：</b>
          {{ table.projectName }}
        </div>
        <div class="rightDiv">
          <!-- 判断是三级个人还是个人 -->
          <b>任务月度：</b>
          {{ table.taskDt }}
        </div>
      </div>
      <!-- 当支付状态不为支付中的时候 -->
      <div class="flexBox borderBtm" v-if="type != 2">
        <div class="leftDiv">
          <b>
            支付{{
              itemData.data.projectStructureType == 2 ? '个体' : '项目参与人'
            }}数：
          </b>
          {{ table.pyaSum }}
        </div>
        <div class="rightDiv">
          <b>项目结算金额：</b>
          {{ (table.orderPrice - table.platformServicesPrice) | moneyFixed }}
        </div>
      </div>
      <div v-if="finalStatus == 2 || finalStatus == 5" v-show="type !== 2">
        <div class="flexBox">
          <div class="leftDiv">
            <b>支付成功金额：</b>
            {{ table.paySuccess[0].totalPrice | moneyFixed }}
          </div>
          <div class="rightDiv">
            <b>
              支付成功{{
                itemData.data.projectStructureType == 2 ? '个体' : '项目参与人'
              }}数：
            </b>
            {{ table.paySuccess[0].payNum }}
          </div>
        </div>
        <div class="flexBox">
          <div class="leftDiv">
            <b>支付失败金额：</b>
            {{ table.payFali[0].totalPrice | moneyFixed }}
          </div>
          <div class="rightDiv">
            <b>
              支付失败{{
                itemData.data.projectStructureType == 2 ? '个体' : '项目参与人'
              }}数：
            </b>
            {{ table.payFali[0].payNum }}
          </div>
        </div>
      </div>
      <div
        style="text-align:right;margin-bottom:50px;"
        v-if="[1, 2].includes(type)"
      >
        平台服务费：
        <b style="font-size:30px;">{{ table.platformServicesPrice | money }}</b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div style="text-align:right;margin-bottom:50px;" class="borderBtm">
        结算总金额：
        <b style="font-size:30px;" v-if="type == 1">
          {{ table.orderPrice | money }}
        </b>
        <b style="font-size:30px;" v-else-if="type == 3">
          {{ (table.orderPrice - table.platformServicesPrice) | money }}
        </b>
        <b style="font-size:30px;" v-else>
          {{ table.platformServicesPrice | money }}
        </b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div class="flexBox" style="justify-content:space-between;">
        <div style="display:flex;">
          <b class="colorBf" style="margin-right:40px;line-height:40px;">
            支付通道：
          </b>
          <el-select v-model="key" class="accountType">
            <el-option value="baofu" label="众邦银行"></el-option>
          </el-select>
        </div>
        <div v-if="finalStatus != 7 && finalStatus != 5">
          <!-- {{ finalStatus == 2 ? "预计支付金额" : "实际支付金额" }}： -->
          实际支付金额：
          <b style="font-size:30px;color:#1989FA;" v-if="type == 1">
            {{ table.leftOrderPrice | money }}元
          </b>
          <b style="font-size:30px;color:#1989FA;" v-else-if="type == 3">
            {{ table.leftOrderPrice | money }}元
          </b>
          <b style="font-size:30px;;color:#1989FA;" v-else>
            {{ table.platformServicesPrice | money }}元
          </b>
        </div>
        <div v-else>
          余额：
          <b style="font-size:30px;color:#1989FA;">
            {{ info.balance | money }}
          </b>
          元
        </div>
      </div>
      <div
        class="hint"
        v-if="finalStatus == 1 || finalStatus == 4"
        style="color:#E90B0B"
      >
        支付完成前，请保证账户内余额充足
      </div>
      <div
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
        v-if="finalStatus == 1 || finalStatus == 4 || finalStatus == 6"
      >
        <el-button
          type="primary"
          style="margin-right:220px;"
          @click="check('sendMsg')"
          :disabled="checkIfPay()"
        >
          支付
        </el-button>
        <el-button
          style="border-radius:4px;border:2px solid rgba(25,137,250,1);color:#1989FA"
          @click="close"
        >
          返回
        </el-button>
      </div>
      <div v-else-if="finalStatus == 3 || finalStatus == 6">
        <el-button
          type="primary"
          @click="check('sendMsg')"
          :disabled="checkIfPay()"
        >
          重新支付
        </el-button>
      </div>
      <div
        v-else
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
      >
        <el-button type="primary" @click="close">确认</el-button>
      </div>
    </el-dialog>
    <component :is="componentName" :type="type"></component>
  </div>
</template>
<script>
import sendMsg from './child/sendMsg.vue';
import payHistory from './child/payHistory.vue';
import deposit from './deposit.vue';
import { bfAccount, threeLevelloadCsoOrder } from '@/api/ajax';
import { projectOrderPayStatus2 } from '@/config/staticData';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number
    }
  },
  data() {
    return {
      projectOrderPayStatus2,
      loading: 0,
      table: {
        payStatus: 0,
        paySuccess: [],
        payFali: [],
        payIng: []
      },
      info: {},
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      componentName: '',
      finalStatus: ''
    };
  },
  filters: {
    transPayStatus(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付失败',
        4: '继续支付',
        5: '支付中',
        6: '支付失败',
        7: '支付成功'
      };
      return s[v];
    }
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    check(componentName) {
      this.componentName = componentName;
    },
    deal(v) {
      return this.projectOrderPayStatus2[v].label;
    },
    checkIfPay() {
      // leftOrderPrice 实际支付金额
      if (this.type === 1) {
        //订单加服务费
        // return this.info.balance < (this.table.orderPrice + this.table.platformServicesPrice)
        return (this.info.balance || 0) < this.table.leftOrderPrice;
      } else if (this.type === 3) {
        //订单
        // return this.info.balance < this.table.orderPrice
        return (this.info.balance || 0) < this.table.leftOrderPrice;
      } else {
        return (this.info.balance || 0) < this.table.platformServicesPrice;
      }
    }
  },
  components: {
    sendMsg,
    payHistory,
    deposit
  },
  async created() {
    try {
      bfAccount().then(res => {
        this.info = res.data.data;
        this.loading += 1;
        this.loadAccount = false;
      });
    } catch (error) {
      this.loading += 1;
    }
    let {
      data: { data }
    } = await threeLevelloadCsoOrder({ id: this.itemData.data.id });
    this.table = data;
    this.loading += 1;
    let ps = this.table.payStatus;
    let as = this.table.authStatus;
    let ss = this.table.servicesPricePayStatus;
    //1: '待支付',2: '审核中', 3: '审核未通过', 4: '部分支付成功',5: '支付中',6: '支付失败',7:'支付成功'
    if (this.type == 2) {
      let s = {
        0: 1,
        1: 5,
        2: 7,
        3: 6
      };
      this.finalStatus = s[ss];
    } else {
      if (ps == 0) {
        if (as == 0) {
          this.finalStatus = 1;
        } else if (as == 1) {
          this.finalStatus = 2;
        } else if (as == 3) {
          this.finalStatus = 3;
        } else if (as == 2) {
          this.finalStatus = 5;
        }
      } else if (ps == 1) {
        this.finalStatus = 5;
      } else if (ps == 2) {
        this.finalStatus = 4;
      } else if (ps == 4) {
        this.finalStatus = 6;
      } else if (ps == 3) {
        this.finalStatus = 7;
      }
    }
    //0 未支付 1 支付中 2 部分支付成功 3 支付成功 4 支付失败'
    // try {
    //   let data2 = await bfAccount();
    //   this.info = data2.data.data;
    // } catch (error) {}
  }
};
</script>
<style lang="scss" scoped>
.flexBox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 26px;
  .leftDiv {
    width: 55%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 2%;
  }
  .rightDiv {
    width: 40%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .midDiv {
    width: 25%;
    text-align: left;
  }
  .timeDiv {
    width: 20%;
    text-align: center;
  }
}
.colorBf {
  color: #bfbfbf;
}
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
  margin-left: 20px;
}
.imgBox {
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.chartDia {
  .borderBtm {
    padding-bottom: 20px;
    border-bottom: 1px solid #efefef;
  }
}
</style>
